import { render, staticRenderFns } from "./NewShop.vue?vue&type=template&id=1d98576c&"
import script from "./NewShop.vue?vue&type=script&lang=js&"
export * from "./NewShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports